import {
	GenTable2Component,
	GenTableComponent,
} from "@app/gen-table/gen-table.component"
import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnInit,
	Output,
	SimpleChange,
	ViewChild,
	booleanAttribute,
	ChangeDetectionStrategy,
} from "@angular/core"
import {
	ConfigDefinitions,
	Followup,
	PatientFormObj,
	Test,
	PatientTestObj,
	TimeStatuses,
	ReportItemType,
	StorePatient,
	Fp_image,
	IsByTypes,
} from "@app/definitions/types"
import * as moment from "moment"
import { MixedListComponent } from "@app/mixed-list/mixed-list.component"
import {
	PersonCommonComponent,
	PersonSideItemComponent,
} from "@app/person-common/person-common.component"
import { getChecked } from "@app/helpers"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { HomeMeetingComponent } from "@app/home-meeting/home-meeting.component"
import { MobileTabsComponent } from "@app/utils/mobile-tabs/mobile-tabs.component"
import { BannerComponent } from "@app/utils/banner/banner.component"
import { SafeHtmlPipe } from "@app/utils/safe-html.pipe"
import { UpdatePatientComponent } from "@app/update-patient/update-patient.component"
import { UpdateGroupComponent } from "@app/update-group/update-group.component"
import {
	BtnExtComponent,
	Check,
	SpinOrContent,
	TestDisplayComponent,
} from "@app/utils/utils.component"
import { NgTemplateOutlet, SlicePipe } from "@angular/common"
import { ReportsComponent } from "@app/reports/reports.component"
import { AddInvoiceComponent } from "@app/add-invoice/add-invoice.component"
import { ImageGalleryComponent } from "@app/image-gallery/image-gallery.component"
import { TestGraphComponent } from "@app/test-graph/test-graph.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { AddPrescriptionComponent } from "@app/add-prescription/add-prescription.component"
import { TestsMenuComponent } from "@app/tests-menu/tests-menu.component"
import { TestschedulesComponent } from "@app/testschedules/testschedules.component"
import { PatientTestInvitesComponent } from "@app/patient-test-invites/patient-test-invites.component"
import { TaskComponent } from "@app/task/task.component"
import { AddDocumentComponent } from "@app/add-document/add-document.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"
import {
	RequireCcFieldComponent,
	RequireDefaultSignatureComponent,
} from "@app/require-fields/RequireCcField.component"
import { endDateNullPipe } from "@app/utils/endDateNull.pipe"
import { FinNumberPipe } from "@app/utils/finNumber.pipe"
import { UploadDocumentComponent } from "@app/upload-document/upload-document.component"
import { SendProformaComponent } from "@app/send-proforma.component"

@Component({
	selector: "proforma-send-btn",
	imports: [COMMON_IMPORTS, BtnExtComponent, SendProformaComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-btn-ext
			[title]="title"
			(clickEv)="isOpen = true"
			[isSpin]="isOpen"
			[iconName]="icon"
		/>
		@if (isOpen) {
			<app-send-proforma
				[patient]="patient"
				[isBy]="isBy"
				(onDone)="isOpen = false"
			/>
		}
	`,
})
export class ProformaSendBtn {
	@Input() isBy: IsByTypes = null
	@Input() patient: any = null
	title: string = ""
	icon: string = ""
	isOpen: boolean = false
	ngOnInit() {
		this.title =
			this.isBy === "sms"
				? "send_sms_proforma"
				: this.isBy === "email"
					? "send_email_proforma"
					: "send_wa_proforma"
		this.icon =
			this.isBy === "sms"
				? "sms_small"
				: this.isBy === "email"
					? "email"
					: "whatsapp"
	}
}

@Component({
	selector: "app-patient",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		DateFormatPipe,
		HomeMeetingComponent,
		MobileTabsComponent,
		BannerComponent,
		SafeHtmlPipe,
		UpdatePatientComponent,
		UpdateGroupComponent,
		SpinOrContent,
		BtnExtComponent,
		PersonSideItemComponent,
		SlicePipe,
		ReportsComponent,
		AddInvoiceComponent,
		ImageGalleryComponent,
		TestGraphComponent,
		ModalWrapComponent,
		AddPrescriptionComponent,
		TestsMenuComponent,
		TestschedulesComponent,
		PatientTestInvitesComponent,
		TaskComponent,
		AddDocumentComponent,
		GenTableDisplayComponent,
		RequireCcFieldComponent,
		RequireDefaultSignatureComponent,
		GenTable2Component,
		NgTemplateOutlet,
		GenTableComponent,
		MixedListComponent,
		Check,
		TestDisplayComponent,
		endDateNullPipe,
		FinNumberPipe,
		UploadDocumentComponent,
		ProformaSendBtn,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./patient.component.html",
})
export class PatientComponent extends PersonCommonComponent {
	//inherits some fields and methods from PersonCommons!
	spinnerFieldName: string = ""

	requireCompProps: any = null

	lastMonth: string = moment
		.utc()
		.subtract(1, "month")
		.format("MMM")
		.toLowerCase()
	personType: ReportItemType = "patient" //used by PersonCommons to generalize
	@Input({ transform: booleanAttribute }) isHomeMeetingOnly: boolean = false
	@Input() patient: any = null //the object that holds the field values (and is saved)
	@Input() followup: Followup
	@Input() isLoading: boolean = false
	@Input() groupAttendRowPatientId: number = 0
	@Input({ transform: booleanAttribute }) isHome: boolean = false
	@Input() timeStatus: TimeStatuses = "present"
	@Input() dayEventsLength: number = 0
	@Input({ transform: booleanAttribute }) openInTests: boolean = false
	@Output() moveToOtherFollowup = new EventEmitter()
	@ViewChild("documentsTable") documentsTable: GenTableComponent
	@ViewChild("prescriptionsTable") prescriptionsTable: GenTableComponent
	@ViewChild("mixedList") mixedList: MixedListComponent

	escSub: any = null
	prevNextSub: any = null
	miscSub: any = null
	patientCollectionsSub: any = null
	isDownloading: boolean = false
	selectedDocumentsObj: any[] = []
	testsChooseAllChecked: boolean = false
	hasCheckedItems: boolean = false
	isSendingMulti: boolean = false
	isFetchingPatientImages: boolean = false
	cc: any = null

	sideItems: any[] = []

	changeCurCenterToPatientDetails() {
		this.curCenter = this.isHome ? "patient_details" : ""
	}

	ngOnDestroy() {
		this.escSub?.unsubscribe()
		this.prevNextSub?.unsubscribe()
		this.miscSub?.unsubscribe()
		this.patientCollectionsSub?.unsubscribe()
		this.mobileChangeSub?.unsubscribe()
	}

	src: any = null

	ngOnInit() {
		this.cc = this.store.cc()

		this.load()
		this.changeSideItems()

		this.curCenter = this.isHome ? "" : ""

		this.escSub?.unsubscribe()
		this.escSub = this.eventsService.escapeKeyNonModalSubj.subscribe(() => {
			this.backToMain()
		})
		this.prevNextSub?.unsubscribe()
		this.prevNextSub = this.store.patientPrevNextSub.subscribe((res: any) => {
			if (this.patient && res.patientId == this.patient.id) {
				this.patient.last_followup = res.last_followup
				this.patient.next_followup = res.next_followup
			}
		})
		this.miscSub?.unsubscribe()
		this.miscSub = this.store.patientMiscSub.subscribe((res: any) => {
			if (this.patient && res.patient_id == this.patient.id) {
				this.store.totalFields.forEach(
					(f) => (this.patient[f] = res.patient[f])
				)
			}
		})
		this.patientCollectionsSub?.unsubscribe()
		this.patientCollectionsSub = this.store.patientCollectionsSub.subscribe(
			(res: any) => {
				if (this.patient && res.patient_id == this.patient.id) {
					this.patient[res.name] = res.collection
					switch (res.name) {
						case "mixed_list":
							if (this.mixedList) {
								this.mixedList.ngOnInit()
							}
							break
						case "documents":
							this.leftSideUpdate(res.collection, "documents")

							if (this.curCenter == "document") {
								this.documentsTable.getItems()
							}
							break
						case "finresources":
							if (this.curCenter == "invoice") {
								this.finresourceTable.getItems()
							}
							break
						case "prescriptions":
							if (this.curCenter == "medicpatient") {
								this.prescriptionsTable.getItems()
							}
							break
						case "tests":
							this.leftSideUpdate(res.collection, "tests")
							break
					}
				}
			}
		)

		//create in store and listen here to invoice table updates

		this.isMobileHandle() //PersonCommons method to handle changes in isMobile
		this.testsChooseAllChecked = false
		this.hasCheckedItems = false
		this.isSendingMulti = false

		if (this.patient) {
			this.postChange()
		}

		if (this.openInTests) {
			this.sideItemClick("test")
		}
	}
	changeSideItems() {
		this.sideItems = [
			//the items on the side column (icon comes from config, should flag (iconIsImg) if it's img. instead of icon. )
			{ name: "patient_remark", title: "remarks", icon: "remarks" },
			{ name: "tasks", title: "tasks", icon: "remarks" },
			{
				name: "contactway",
				title: "contactway",
				icon: "contactway",
				iconIsImg: true,
			},
			{ name: "diagppatient", title: "diagps", icon: "diagp", iconIsImg: true },
			{
				name: "mixed_list",
				title: "mixed_list",
				icon: "mixed_list",
				iconIsImg: true,
			},
			/* {name: 'reminder', title: 'reminders', icon: 'reminder', iconIsImg: true },*/
			{ name: "invoice", title: "financial", icon: "money", iconIsImg: true },
			{
				name: "document",
				title: "documents",
				icon: "document",
				iconIsImg: true,
			},
			{ name: "test", title: "tests", icon: "test1", iconIsImg: true },
			{
				name: "medicpatient",
				title: "medics",
				icon: "medic1",
				iconIsImg: true,
			},
			{
				name: "nondrugpatient",
				title: "nondrugs",
				icon: "nondrug1",
				iconIsImg: true,
			},
			{
				name: "labtestpatient",
				title: "labtests",
				icon: "labtest",
				iconIsImg: true,
			},
			{
				name: "details",
				title: "group_details",
				icon: "group",
				iconIsImg: false,
			},
		]

		if (
			this.patient?.is_group == "yes" &&
			this.patient?.charge_mode == "by_participant"
		) {
			const areasToRemove = [
				"contactway",
				"diagppatient",
				"medicpatient",
				"nondrugpatient",
				"labtestpatient",
				"test",
			]
			this.sideItems = this.sideItems.filter(
				(it) => !areasToRemove.includes(it.name)
			)
		}
		if (
			this.patient?.is_group == "yes" &&
			this.patient?.charge_mode == "by_group"
		) {
			const areasToRemove = [
				"contactway",
				"diagppatient",
				"medicpatient",
				"nondrugpatient",
				"labtestpatient",
				"test",
			]
			this.sideItems = this.sideItems.filter(
				(it) => !areasToRemove.includes(it.name)
			)
		}

		if (
			this.permsService.owner_has_users &&
			!this.permsService.perms?.clinical &&
			this.sideItems.find((it) => it.name == "medicpatient")
		) {
			const areasToRemove = [
				"medicpatient",
				"nondrugpatient",
				"diagppatient",
				"labtestpatient",
				"mixed_list",
			]
			this.sideItems = this.sideItems.filter(
				(it) => !areasToRemove.includes(it.name)
			)
		}
		if (
			!this.permsService?.perms?.clinic_financial &&
			!this.permsService?.perms?.administrative &&
			this.sideItems.find((it) => it.name == "invoice")
		) {
			const areasToRemove = ["invoice"]
			this.sideItems = this.sideItems.filter(
				(it) => !areasToRemove.includes(it.name)
			)
		}

		const zonesCc = this.cc?.zones
		if (!zonesCc?.length) {
			this.sideItems = this.sideItems.filter((it) => it.name != "tasks")
		}
		if (zonesCc && zonesCc?.length) {
			const newSiteItems: any[] = []
			zonesCc.forEach((zone_id) => {
				const zoneName = this.store.searchSiteDataItem(zone_id, ["zones"])?.name
				const sideItem = this.sideItems.find((si) => si.name == zoneName)
				if (sideItem) {
					newSiteItems.push(sideItem)
				}
			})
			if (this.patient?.is_group == "yes") {
				const sideItem = this.sideItems.find((si) => si.name == "details")
				if (sideItem) {
					newSiteItems.push(sideItem)
				}
			}

			this.sideItems = [...newSiteItems]
		}
	}
	async onIdChange() {
		this.patient = await this.store.getPatient(+this.id)
		this.postChange()
	}

	async ngOnChanges(changes: SimpleChange) {
		//if person changed (ex: contact) - send to load function
		if (changes[this.personType]) {
			this.postChange()
		}
		if (changes["id"]) {
			console.log(this.id)
			this.onIdChange()
		}
	}
	postChange() {
		if (this.patient?.id && this.id !== this.patient.id) {
			this.id = this.patient.id
		}
		this.load()
		this.changeSideItems()
		this.prepTestAnswers()
	}

	perpOtherSideCols() {
		const colsToUpdate = ["medicpatients", "diagppatients", "nondrugpatients"]
		colsToUpdate.forEach((colName) => {
			this.leftSideUpdate(this.patient[colName], colName)
		})
	}

	leftSideUpdate(rows: any[], patientTableToUpate: string) {
		//
		// if (["medicpatients","diagppatients","nondrugpatients"].includes(patientTableToUpate)) {
		//   rows = rows.filter(item => item.end_date == null);
		// }
		this.patient[patientTableToUpate] = [...rows]
	}

	async getPatientImages() {
		if (this.isFetchingPatientImages) {
			return
		}
		this.isFetchingPatientImages = true
		const images = await this.apiService.post("get_fp_images", {
			patient_id: this.patient.id,
		})
		this.isFetchingPatientImages = false
		this.modalProps = {
			name: "image-gallery",
			images,
		}
	}
	getDocumentTitle() {
		return `${this.patient.name} ${
			this.patient.id_number
				? `${this.lang.getVal("id_number")} ${this.patient.id_number}`
				: ""
		}`
	}
	addDocument() {
		this.modalProps = {
			name: "add-document",
			patient_id: this.patient.id,
			title: this.getDocumentTitle(),
		}
	}
	addMedicalLetter() {
		this.modalProps = {
			name: "add-document",
			patient_id: this.patient.id,
			title: this.getDocumentTitle(),
			followup: this.followup || null,
			isMedicalLetter: true,
		}
	}

	updateFinResourceIds(arrItems: any[]) {
		this.selectedDocumentsObj = arrItems
	}
	sideItemClickFinish(name: string) {
		this.curCenter = name
		this.updateShowColumnLocal("center")
		this.scrollToCenter()
	}
	async sideItemClick(name: string) {
		if (name === "details") {
			return this.changeCurCenterToPatientDetails()
		}
		if (name == "tasks") {
			this.modalProps = { name: "task" }
			return
		}
		if (name == "document") {
			this.requireCompProps = { name: "defaultSignature", sideItemName: name }
			return
		}
		this.sideItemClickFinish(name)
	}
	handleDefaultSigClose(ret: any = null) {
		const { sideItemName } = this.requireCompProps
		this.requireCompProps = null
		if (ret) {
			this.sideItemClickFinish(sideItemName)
		}
	}
	handleAddPrescriptionClose(retItem: any = null) {
		if (retItem?.patientChanged) {
			if (retItem?.patient_id_number_dec !== undefined) {
				this.patient.id_number = retItem?.patient_id_number_dec
			}
			if (retItem?.address_dec !== undefined) {
				this.patient.address = retItem?.address_dec
			}
			this.store.updatePatient(this.patient)
		}

		this.scrollTop()
	}
	handleRequirePrescriptionSigClsoe(ret: any = null) {
		if (ret) {
			this.modalProps = {
				name: "add-prescription",
			}
		}
	}

	prepTestAnswers() {
		if (!this.patient) {
			return
		}
		this.store.getPatientWithPreppedTests(this.patient.id)
	}

	getTestHtml(test: PatientTestObj) {
		let html = ""
		if (test?.tests?.length) {
			for (let testInner of test.tests) {
				html += `
        <div>
          <h3>${testInner.name}</h3>
          ${this.getTestHtml(testInner)}
        </div>`
			}
		}
		if (test?.questions?.length) {
			for (let ques of test.questions) {
				html += `
        <div>
          <b style="display: block;">${ques.q}</b>
          ${ques.a}
        </div>`
			}
		}
		return html
	}

	async download_testfill(testRow: any) {
		testRow.isDownloading = true

		this.store.downloadToastFunc(async () => {
			const res = await this.apiService.download("download_testfill", {
				id: testRow.testfill_id,
			})
			testRow.isDownloading = false
			if (!res?.size) {
				return this.store.downloadFailedModal(50)
			}
			this.apiService.downloadFile(res, this.lang.getVal("test") + ".pdf")
		})
	}

	async openTestGraph(test_id: number) {
		this.modalProps = {
			name: "test-graph",
			test_id,
		}
	}

	async refreshTestfills() {
		const res = await this.apiService.post("get_patient_test_fills_answers", {
			patient_id: this.patient.id,
		})
		if (res?.testfills) {
			this.store.removeDecArr(res.testanswers)
			this.store.removeDecArr(res.testfills)
			this.store.updatePatientGenCollection(
				this.patient.id,
				res.testfills,
				"testfills"
			)
			this.store.updatePatientGenCollection(
				this.patient.id,
				res.testanswers,
				"testanswers"
			)

			this.prepTestAnswers()
		}
	}

	testsChooseAll() {
		this.patient.tests.forEach((t) => (t.checked = this.testsChooseAllChecked))
		this.postTestChoose()
	}
	postTestChoose() {
		this.hasCheckedItems = !!this.patient.tests.find((t) => t.checked)
	}
	async printTests() {
		const selectedItems = getChecked(this.patient.tests)
		if (!selectedItems.length) {
			return
		}
		for (let obj of selectedItems) {
			await this.store.downloadToastFunc(async () => {
				const res = await this.apiService.download("download_testfill", {
					id: obj.testfill_id,
				})
				if (!res?.size) {
					return this.store.downloadFailedModal(50)
				}
				this.apiService.downloadFile(res, "test-" + obj.testfill_id + ".pdf")
			})
		}
	}
	sendTests() {
		if (!getChecked(this.patient.tests).length) {
			return
		}
		this.modalProps = {
			name: "table-display-contactways",
			...this.store.phoneEmailValidationAttrs(),
		}
	}
	async handleContactwaysClose(contactways: any[]) {
		const testfill_ids = getChecked(this.patient.tests).map(
			(it) => it.testfill_id
		)
		const contactway_ids = contactways.map((row) => row.id)
		this.isSendingMulti = true
		const res: any = await this.apiService.post("email_tests", {
			testfill_ids,
			contactway_ids,
		})
		this.modalService.openToast("sent_to")
		this.isSendingMulti = false
	}
}
